import { Dimensions } from "react-native";

let W = Dimensions.get("window").width;

Dimensions.addEventListener("change", (e) => {
  const { width } = e.window;
  W = width;
});

function sizeNormalizer<T, U, K, X>(
  max_576: T,
  max_768?: U,
  max_992?: K,
  min_1200?: X
) {
  return W < 576
    ? max_576
    : W < 768
    ? max_768 ?? max_576
    : W < 992
    ? max_992 ?? max_576
    : min_1200 ?? max_576;
}

export default sizeNormalizer;
